module.exports = __webpack_public_path__ + "img/ariel.78bb8e79.png";